module.exports = __webpack_public_path__ + "img/1.7a4f0cea.png";